import { render } from "./ConvertToPendingPal.vue?vue&type=template&id=def87568&ts=true"
import script from "./ConvertToPendingPal.ts?vue&type=script&lang=ts&external"
export * from "./ConvertToPendingPal.ts?vue&type=script&lang=ts&external"

import "./ConvertToPendingPal.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__